<template>
    <div class="col-md-12">
    <b-alert :variant="alert.type"
        dismissible
        fade
        :show="alert.show"
        @dismissed="alert.show=false"
    >{{ alert.message }}</b-alert>
        <div class="card">
            <div class="card-header">
                <h4 class="float-left mt-2 mb-0">Shippingservice-Preselection-Regeln <span v-if="readOnly">(read only)</span></h4>
                <button v-if="!readOnly" type="button" class="btn btn-secondary btn-md ml-1 float-right" @click="createItem()">
                    <span class="icon icon-plus"></span>
                </button>
        <b-form-select 
          class="float-right col-md-1 mx-1" 
          id="selectShippingType"
          :options="shippingTypes"
          v-model="selectedShippingType"
          :disabled="pendingChanges">
        </b-form-select>
        <b-form-select 
          class="float-right col-md-5 col-xl-4 col-sm-10" 
          id="selectGroup"
          :options="groups"
          v-model="selectedGroup"
          :disabled="pendingChanges">
        </b-form-select>
            </div>
            <div class="card-body">
                <table class="table-editable table table-hover">
                    <tbody>
                        <tr>
                            <th class="text-center">Gewicht (Mat netto) bis</th> <!-- unsigned int -->
                            <th class="text-center">VK bis</th> <!-- unsigned float  -->
                            <th class="text-center">Masse</th>
                            <th class="text-center">Versanddienstleister</th>
                            <th class="text-center bg-light">max. Volumengewicht</th>
                            <th class="text-center bg-light">alt. Versanddienstleister</th>
                            <th></th>
                        </tr>
                        <tr v-for="(item, itr) in items" v-bind:key="itr"
                            v-bind:style="{'border-bottom': (itr < (items.length - 1)
                            && items[itr]?.mdFlagSet
                            && (items[itr+1]?.mdFlagSet === 0 || items[itr+1]?.mdFlagSet === null)) ? 'solid 2px black' : '1px'}">
                            <td>
                              <div class="input-group">
                                <input type="text" class="form-control" required v-model="item.toWeight" :disabled="readOnly">
                                <div class="input-group-append mb-auto"><span class="input-group-text">g</span></div>
                              </div>
                            </td>
                            <td>
                              <div class="input-group">
                                <input type="text" class="form-control" required v-model="item.toVK" :disabled="readOnly">
                                <div class="input-group-append mb-auto"><span class="input-group-text">€</span></div>
                              </div>
                            </td>

                            <td>
                              <b-select id="select-md-flag-set" v-model="item.mdFlagSet" :options="mdFlagSetOptions" ></b-select>
                            </td>

                            <td>
                              <b-form-select id="selectShippingServices"
                                :options="shippingServices"
                                v-bind:value="item.shippingService"
                                v-model="item.shippingService"
                                :disabled="readOnly"
                              ></b-form-select>
                            </td>

                            <td class="bg-light">
                                <div class="input-group">
                                  <input type="text" class="form-control" required v-model="item.maxVolumeWeight" :disabled="readOnly">
                                  <div class="input-group-append mb-auto"><span class="input-group-text">g</span></div>
                                </div>
                            </td>

                            <td class="bg-light">
                              <b-form-select id="selectAlternativeShippingServices"
                                :options="shippingServices"
                                v-bind:value="item.alternativeShippingService"
                                v-model="item.alternativeShippingService"
                                :disabled="readOnly"
                              ></b-form-select>
                            </td>

                            <td v-if="!readOnly">
                                <button type="button" class="btn btn-md float-right" @click="deleteItem(itr)">
                                    <span class="icon icon-bin"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <button v-if="!readOnly" type="button" class="btn btn-primary float-right" @click="save()">
                    Speichern
                </button>
            </div>
        </div>

    <div><!-- modal wait dialogue -->
      <b-modal 
        v-model="modalSpinnerState"
        size="sm"
        centered
        hide-footer hide-header 
        no-close-on-esc
        no-close-on-backdrop
        dismissible
        >
        <div class="modal-body">
          <div class="text-center justify-content-between">
            Bitte Warten
          </div>
          <div class="row"></div>
          <div class="text-center justify-content-between">
            <img class="custom-spinner" id="customSpinner1" src="/images/124-spinner2.png" />
          </div>

        </div>
      </b-modal>
    </div>
    </div>

</template>

<script>
    export default {
        props: ['passedGroups', 'readOnly'],
        data() {
            return {
                mdFlagSetSelection: null,
                mdFlagSetOptions: [
                   { text: "-", value: 0 },
                   { text: "Brief", value: 67108864 },
                   { text: "Warenpost DE", value: 134217728 },
                   { text: "Warenpost Int.", value: 268435456 },
                   { text: "Spring Brief", value: 536870912 },
                   { text: "Spring Boxable", value: 1073741824 },
                   { text: "PostNL Letterbox Plus", value: 131072 },
                   { text: "DHL Kleinpaket", value: 2 },
									 { text: "Spring Paket US", value: 2048 },
                ],
                items: [],
                nextSelectionIndexValue: 0,          //the index  for a given rule. e.g. fuer : Max{items s.d. items.gorup == asldkj} + 1
                groups: [],
        selectedGroup: { id: 1 },
        selectedShippingType: "0",
        modalSpinnerState: false,
        modalSpinnerStateDebounced: false,
        shippingTypes: {
          0: 'Allgemein',
          2: 'Express'
        },
        shippingServices: {
          null: '',
          0:  'k/A',
          2:  'DHL Paket',
          3:  'FedEx',
          4:  'UPS',
          5:  'DHL Paket FSK',
          6:  'DHL World Express',
          11: 'Spring Paket',
          13: 'Spring Trackable (RFID)',
          14: 'Spring Untracked',
          16: 'DHL Economy Express',
          18: 'ETD EU to TR',
          19: 'Spring Trackable Boxable (RFID)',
          20: 'Spring Untracked Boxable',
          22: 'DHL Kleinpaket',
          25: 'FedEx ICP',
          26: 'DP Warenpost Int. UNTRACKED',
          27: 'DP Warenpost Int. Tracked (R)',
          28: 'Spring RM48 DDP',
          29: 'DHL Paket DDP',
          30: 'PostNL Letterbox Plus',
          31: 'Spring Paket DDP',
					32: 'Spring RM48',
					33: 'Spring RM24',
					34: 'Spring RM24 DDP',
					35: 'Spring Evri48',
					36: 'Spring Evri48 DDP',
          101: 'Express Manager'
        },

        //Alert
        alert: {
          show: false,
          message: null,
          type: null,
        },
        alertSaveSwitch: false,
        pendingChanges: false,
        customSpinnerDeg:0,
            }
        },

    watch:  {
      selectedShippingType: function() {
        this.loadItems();
      },
      selectedGroup: function() {
        this.loadItems();
      },
      items: {
        handler: function(nv, ov) {
          this.pendingChanges = true;
          console.log("item handler");
        },
        deep: true
      },
    },
    methods: {

      loadItems() // Rules are not passed to the view, they are loaded dynamically (need to be reloaded after rule has been changed):
      {
        this.modalSpinnerState = true;
        var uri ='/shippingservicepreselectionrule/items/' + this.selectedGroup.id + '/' + this.selectedShippingType;
        console.log(uri);
        axios.get(uri).then(
              (response) => {
                this.items = response.data;
                this.nextSelectionIndexValue = 0;
                for(let item of this.items)
                {
                  if(item.selectionIndex >= this.nextSelectionIndexValue)
                  {
                    this.nextSelectionIndexValue = item.selectionIndex + 1;
                  }
                }  
                Vue.nextTick(() => {
                  this.pendingChanges = false;
                  this.modalSpinnerState = false;
                })
                console.log('Items loaded.');
                if(!this.alertSaveSwitch)
                {
                  this.showAlert('success', "Laden der Daten erfolgreich.");
                }
              }
            )
            .catch(
              (error) => {
                console.dir(error);
                this.modalSpinnerState = false;
                this.showAlert('danger', "Laden der Daten fehlgeschlagen.");
              }
            );
      },

      showAlert(type, message)
      {
        this.alert = {
          type: type,
          message: message,
          show: true
        };
        setTimeout(
          () => { this.alert.show = false },
          5000
        );
      },
			save()
			{
        // sanity check all input for all rules
        for(let item of this.items)
        {
          if(_.isString(item.toVK))
          {
            item.toVK  = item.toVK.replace(',', '.');
          }
          if(_.isString(item.toWeight))
          {
            item.toWeight  = item.toWeight.replace(',', '.');
          }
          if(_.isString(item.maxVolumeWeight))
          {
            item.maxVolumeWeight  = item.maxVolumeWeight.replace(',', '.');
          }
					
					if(item.toWeight == "") item.toWeight = null;
					if(item.toVK == "") item.toVK = null;
					if(item.maxVolumeWeight == "") item.maxVolumeWeight = null;

          if(item.shippingType == 0 || item.shippingType == "0")
          {
            item.shippingType = null;
          }

          //replace shippingService with index:
          //item.shippingService = this.shippingServices.findIndex((v) => {return v.shippingService == item.shippingService)});
        }
        this.modalSpinnerState = true;
        console.log(this.items);
        axios.post('/shippingservicepreselectionrule/save', this.items)
        .then((response) => {
          console.log(response);
          this.showAlert('success', 'Speichern erfolgreich');
          this.alertSaveSwitch = true;
          this.loadItems();
          this.modalSpinnerState = false;
        })
        .catch((error) => {
          console.dir(error)
          this.modalSpinnerState = false;
          this.showAlert('danger', 'Änderungen wurden aufgrund eines Fehlers nicht gespeichert. Drücken Sie speichern um es erneut zu versuchen.');
        });

      },
      deleteItem(itr)
      {
        if(confirm('Wirklich löschen?'))
        {
          if(this.items[itr].id == null)
          {
            this.items.splice(itr, 1);
          }
          else
          {
            this.modalSpinnerState = true;
            axios.post('shippingservicepreselectionrule/' + this.items[itr].id + '/remove', null)
              .then( () => {
                this.items.splice(itr,1)
                this.modalSpinnerState = false;
                this.showAlert('success', 'Löschvorgang erfolgreich.');
              })
              .catch( (error) => {
                this.modalSpinnerState = false;
                this.showAlert('danger', 'Löschvorgang fehlgeschlagen.');
                console.dir(error);
              });
          }
        }
      },
      createItem()
      {
        console.log('called createItem()');

        //determine next SelectionIndex:
        var max = 0;
        for(let item of this.items)
        {
          if (max < item.selectionIndex)
          {
            max = item.selectionIndex;
          }
        }
        this.nextSelectionIndexValue = max + 1;

        this.items.push({
          id: null,
          shippingServicePreselectionGroupId: this.selectedGroup.id,
          shippingType:this.selectedShippingType,
          selectionIndex:this.nextSelectionIndexValue,
          toWeight: null,
          toVK: null,
          shippingService: 0,
          maxVolumeWeight: null,
          alternativeShippingService: null
          });
        console.log(this.items);
        this.nextSelectionIndexValue++;
      }

    },
    created() {
      this.groups = this.passedGroups.map((group) => { return { value: group, text: group.name } });

      this.groups.sort((a,b) => {
        return a.text.localeCompare( b.text);
      });

      if(this.groups.length > 0) {
        this.selectedGroup = this.groups[0].value;
      }

      let dump = [];
      _.forIn(this.shippingServices, function(value, key) {
        dump.push({
          value: parseInt(key),
          text: value
        });
      });

      dump.sort((a,b) => {
        return a.text.localeCompare( b.text);
      });
      this.shippingServices = dump;

    },
    mounted()
        {
            console.log('Shipping Serive Preselection Editor mounted.');
            this.loadItems();

      // setInterval(
      //   () => {
      //     // this.customSpinnerDeg = (this.customSpinnerDeg + 30) % 360;
      //     // document.getElementById('customSpinner1').style = 'transform: rotate(' + this.customSpinnerDeg + 'deg)';        
      //   },
      //   100
      // );

      //console.log("readOnly: " + this.readOnly);
      //console.log("readOnly type: " + typeof this.readOnly);
        }        
    }
</script>

